import { FormConfigBase } from './abstract/form-config-base.class';
import { RadioCardListInterface } from '../interfaces/radio-card-list.interface';
import { RadioCardModel } from './radio-card.model';

export class RadioCardListModel extends FormConfigBase {
  radioCardList: RadioCardModel[];

  constructor( obj: RadioCardListInterface ) {
    super( obj );

    this.radioCardList = obj && obj.radioCardList && obj.radioCardList.length > 0
      ? obj.radioCardList.map( radioOpt => new RadioCardModel( radioOpt ) )
      : [];
  }

}
